import { render, staticRenderFns } from "./shop.vue?vue&type=template&id=62fa1d68"
var script = {}
import style0 from "./shop.vue?vue&type=style&index=0&id=62fa1d68&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports